import { Component } from '@angular/core';
import {
  ColDef,
  GetRowIdFunc,
  GetRowIdParams,
  GridApi,
  GridReadyEvent,
  ICellEditorParams,
  ValueParserParams,
} from 'ag-grid-community';
import { TableSelectComponent } from './components/table-select/table-select.component';
import { ICellEditor } from './interfaces/cell-editor.interface';
import { RowActionComponent } from './row-action/row-action.component';

export class ColumnDef {
  headerName: string | undefined;
  unSortIcon: boolean;
  field: string | undefined;
  minWidth: number | undefined;
  sortable: boolean | undefined;
  editable: any;
  singleClickEdit: boolean | undefined;
  valueParser: any;
  cellRendererSelector: any;
  cellEditorSelector: any;
  cellRenderer: any;
  cellRendererParams: any;
  cellEditorPopup: any;
  cellEditor: any;
  constructor(
    row: ColDef,
    isEditable: boolean = false,
    isValueParser: boolean = false,
    cellEditor?: ICellEditor | undefined,
  ) {
    this.headerName = row.headerName;
    this.field = row.field;
    this.minWidth = row.minWidth;
    this.sortable = true;
    this.singleClickEdit = true;
    this.editable = isEditable ? this.isEditable : null;
    this.valueParser = isValueParser ? this.numberParser : null;
    this.unSortIcon = false;
    this.cellRendererSelector = () => {
      if (cellEditor?.controller === 'select') {
        return {
          component: TableSelectComponent,
          params: {
            options: cellEditor?.value,
          },
        };
      } else {
        return undefined;
      }
    };
  }

  numberParser(params: ValueParserParams): number | string {
    return Number.isNaN(Number(params.newValue)) ? params.oldValue : Number(params.newValue);
  }

  isEditable(params: any) {
    return params.node.selected;
  }
}
